import { render, staticRenderFns } from "./TrainFrequency.vue?vue&type=template&id=7c49b4cd&scoped=true"
import script from "./TrainFrequency.vue?vue&type=script&lang=js"
export * from "./TrainFrequency.vue?vue&type=script&lang=js"
import style0 from "./TrainFrequency.vue?vue&type=style&index=0&id=7c49b4cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c49b4cd",
  null
  
)

export default component.exports